import React from 'react';
import {
  DatePickerComponent,
  Inputs,
  SelectComponet,
  SwitchComponent,
} from '../../../../../../Components';
import moment from 'moment';
import LookupAutocomplete from '../../../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import { StaticLookupsIds } from '../../../../../../assets/json/StaticLookupsIds';
import { getErrorByName } from '../../../../../../Helper';

const daysOfWeek = [
  { dayOfWeekName: 'Sunday', dayOfWeek: 0 },
  { dayOfWeekName: 'Monday', dayOfWeek: 1 },
  { dayOfWeekName: 'Tuesday', dayOfWeek: 2 },
  { dayOfWeekName: 'Wednesday', dayOfWeek: 3 },
  { dayOfWeekName: 'Thursday', dayOfWeek: 4 },
  { dayOfWeekName: 'Friday', dayOfWeek: 5 },
  { dayOfWeekName: 'Saturday', dayOfWeek: 6 },
];
const FieldsMapper = ({
  data,
  setData,
  parentTranslationPath,
  schema,
  isSubmitted,
}) => {
  const setDataHandler = (field, value) => {
    setData({ key: field, value });
  };
  const { serviceSettingId, vendorId, ...rest } = data;
  return (
    <div className='flex childs-wrapper fj-center fa-center flex-wrap p-3 gap-1'>
      {Object.entries(rest).map(([key, value]) => {
        switch (typeof value) {
          case 'boolean':
            return (
              <div className='w-20'>
                <SwitchComponent
                  isChecked={value}
                  onChangeHandler={(_e, checked) =>
                    setDataHandler(key, checked)
                  }
                  labelValue={key}
                  parentTranslationPath={parentTranslationPath}
                />
              </div>
            );
          case 'string':
            const isValidDate = moment(value).isValid();
            return (
              <div className='w-20'>
                {isValidDate ? (
                  <DatePickerComponent
                    value={value}
                    onDateChanged={(e) =>
                      setDataHandler(key, moment(e).format('YYYY-MM-DD HH:mm'))
                    }
                    labelValue={key}
                    parentTranslationPath={parentTranslationPath}
                    isTimePicker
                    error={getErrorByName(schema, key).error}
                    helperText={getErrorByName(schema, key).message}
                    isSubmitted={isSubmitted}
                  />
                ) : (
                  <Inputs
                    value={value}
                    onInputChanged={(e) => setDataHandler(key, e.target.value)}
                    labelValue={key}
                    parentTranslationPath={parentTranslationPath}
                    error={getErrorByName(schema, key).error}
                    helperText={getErrorByName(schema, key).message}
                  />
                )}
              </div>
            );
          case 'number':
            return (
              <div className='w-20'>
                <Inputs
                  value={value}
                  onInputChanged={(e) =>
                    setDataHandler(key, e.target.valueAsNumber)
                  }
                  labelValue={key}
                  type='number'
                  parentTranslationPath={parentTranslationPath}
                  error={getErrorByName(schema, key).error}
                  helperText={getErrorByName(schema, key).message}
                />
              </div>
            );
          case 'object':
            if (Array.isArray(value)) {
              if (key === 'daysOfOperation') {
                return (
                  <div style={{ minWidth: '20%' }}>
                    <SelectComponet
                      isSubmitted={isSubmitted}
                      data={daysOfWeek}
                      value={value.map((item) => item.dayOfWeek)}
                      labelValue={key}
                      multiple
                      textInput={'dayOfWeekName'}
                      valueInput={'dayOfWeek'}
                      parentTranslationPath={parentTranslationPath}
                      isWithError
                      error={getErrorByName(schema, key).error}
                      helperText={getErrorByName(schema, key).message}
                      onSelectChanged={(value) => {
                        setDataHandler(
                          key,
                          daysOfWeek.filter((item) =>
                            value.includes(item.dayOfWeek)
                          )
                        );
                      }}
                      renderValue={(item) =>
                        daysOfWeek
                          .filter((i) => item.includes(i.dayOfWeek))
                          .map((i) => i.dayOfWeekName)
                          .join(', ')
                      }
                    />
                  </div>
                );
              }
              if (key === 'citiesCovered' && data.specificAreaCovered) {
                return (
                  <div style={{ minWidth: '20%', maxWidth: '50%' }}>
                    <LookupAutocomplete
                      parentTranslationPath={parentTranslationPath}
                      lookupTypeId={StaticLookupsIds.Cities}
                      selectedValues={value.map((item) => ({
                        lookupItemId: item.cityId,
                        lookupItemName: item.cityName,
                      }))}
                      error={getErrorByName(schema, key).error}
                      helperText={getErrorByName(schema, key).message}
                      multiple
                      isSubmitted={isSubmitted}
                      onChange={(_e, newValue) =>
                        setDataHandler(
                          key,
                          newValue.map((item) => ({
                            cityId: item.lookupItemId,
                            cityName: item.lookupItemName,
                          }))
                        )
                      }
                      label={key}
                    />
                  </div>
                );
              }
            }
          default:
            return null;
        }
      })}
    </div>
  );
};
export default FieldsMapper;
